import React from 'react';

import { observer } from 'mobx-react-lite';
import { FHRequestAttachmentType } from 'stores/fhrequest_attachment_store';
import useStores from 'hooks/useStores';
import { CursorType } from "utils/types"

type FHRequestAttachmentContextType = {
    fetchListByRequest: (request: string, cursor?: CursorType) => Promise<FHRequestAttachmentType[]>;
    getListByRequest: (request: string) => FHRequestAttachmentType[];
    fetchSignedUrl: (attachment: string, disposition: string) => Promise<string|null>;
    items: FHRequestAttachmentType[];
}

export const FHRequestAttachmentContext = React.createContext<FHRequestAttachmentContextType>({
    fetchListByRequest: () => { throw 'Not Implemented' },
    getListByRequest: () => { throw 'Not Implemented' },
    fetchSignedUrl: () => { throw 'Not Implemented' },
    items: [] as FHRequestAttachmentType[],
});




export const FHRequestAttachmentProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { fhRequestAttachmentStore } = useStores();


    const fetchListByRequest = async (request: string, cursor?: CursorType) => {
        const response = await fhRequestAttachmentStore
            .fetchListByRequest(request, cursor);
        return response;
    };

    const fetchSignedUrl = async (attachment: string, disposition: string) => {
        const response = await fhRequestAttachmentStore
            .fetchSignedUrl(attachment, disposition);
        return response;
    };


    const getListByRequest = (request: string) => {
        return fhRequestAttachmentStore
            .items
            .filter((item: FHRequestAttachmentType) => item.request === request)
            .sort((a, b) => a.date_created > b.date_created ? 1 : -1);
    };

    const data = {
        fetchListByRequest,
        getListByRequest,
        items: fhRequestAttachmentStore.items,
        fetchSignedUrl,
    };

    return (
        <FHRequestAttachmentContext.Provider value={data}>{ children }</FHRequestAttachmentContext.Provider>
    );

});
